module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/logo@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/logo@2x.png
// module id = 1221
// module chunks = 0